const styles = {
  list: {
    padding: 0,
  },
  delete: {
    color: '#D7394C',
    fontSize: '14px',
    fontWeight: 400,
    paddingLeft: '5px',
  },
};

export default styles;
